import { Button, PlusIcon, Tooltip } from "melco-ui";
import { useTranslation } from "react-i18next";

type AddIntegrationButtonProps = {
    setDrawerOpen: (isDrawerOpen: boolean) => void;
    disabled?: boolean
};

export const AddIntegrationButton: React.FC<AddIntegrationButtonProps> = ({ disabled, setDrawerOpen, }) => {
    const { t } = useTranslation();

    return (
        <> {disabled ?
            <Tooltip title={t("eodsettings.actions.add.tooltip")}>
                <Button
                    key="create-integration"
                    type="primary"
                    icon={<PlusIcon />}
                    disabled={disabled}
                    onClick={() => {
                        setDrawerOpen(true);
                    }}

                >

                    {t("eodsettings.actions.add.button")}
                </Button>
            </Tooltip>
            :
            <Button
                key="create-integration"
                type="primary"
                icon={<PlusIcon />}
                disabled={disabled}
                onClick={() => {
                    setDrawerOpen(true);
                }}

            >

                {t("eodsettings.actions.add.button")}
            </Button>
        }
        </>
    );
};
